export enum StorageKey {
  UserId = 'uid',
  Source = 'src',
  BirthDate = 'bdate',
  PartnerBirthDate = 'pbdate',
}

export const removeLocalStorage = (key: string): void => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(key);
  }
};

export const setLocalStorage = <T>(key: string, value: T): void => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(key, JSON.stringify(value));
  }
};

export const getLocalStorage = <T>(key: string): T | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  try {
    const data = localStorage.getItem(key);
    return data ? (JSON.parse(data) as T) : undefined;
  } catch (error) {
    console.warn(`Failed to parse localStorage key "${key}":`, error);
    return undefined;
  }
};
